import {
    GET_EVALUATION_LIST
} from "../types/evaluationType";

const initialState = {
    evaluations: [],
    vulnSubScanStatus: "not_started",
    vulnSubScanCancelStatus: "not_requested",
    vulnSubScanRetryCount: 0,
    riskReportStatus: "not_started",
    retryVulnSubScanAllowed: false,
    cancelVulnSubScanAllowed: false,
    loading: false,
    error: null
};

const evaluationReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EVALUATION_LIST:
            console.log("test ok");
            {
                const payload = action.payload || {};
                const phases = Array.isArray(payload?.phases)
                    ? payload.phases
                    : Array.isArray(payload)
                    ? payload
                    : [];
                const vulnSubScanStatus = payload?.vulnSubScanStatus || "not_started";
                const vulnSubScanCancelStatus =
                    payload?.vulnSubScanCancelStatus || "not_requested";
                const vulnSubScanRetryCount = Number(payload?.vulnSubScanRetryCount || 0);
                const riskReportStatus = payload?.riskReportStatus || "not_started";
                const retryVulnSubScanAllowed = Boolean(payload?.retryVulnSubScanAllowed);
                const cancelVulnSubScanAllowed = Boolean(payload?.cancelVulnSubScanAllowed);
            return {
                ...state,
                evaluations: phases,
                vulnSubScanStatus,
                vulnSubScanCancelStatus,
                vulnSubScanRetryCount,
                riskReportStatus,
                retryVulnSubScanAllowed,
                cancelVulnSubScanAllowed,
                loading: false
            };
            }
        default:
            return state;
    }
};

export default evaluationReducer;
